/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { omit, pick } from "lodash";
import * as React from "react";
import { Controller, } from "react-hook-form";
import { Checkbox } from "../inputs/Checkbox";
const CONTROLLER_PROP_KEYS = [
    "name",
    "rules",
    "onFocus",
    "defaultValue",
    "control",
];
function splitProps(props) {
    return [
        pick(props, CONTROLLER_PROP_KEYS),
        omit(props, CONTROLLER_PROP_KEYS),
    ];
}
export const ControlledInputBase = ({ render = () => React.createElement(React.Fragment, null), ...props }) => React.createElement(Controller, { ...props, render: (props, state) => render(props, state) });
export const ControlledEmpty = (props) => (React.createElement(ControlledInputBase, { ...props, render: () => React.createElement(React.Fragment, null) }));
export const ControlledCheckbox = ({ nullValue, onChange: onChangeExternal, infoText, ...props }) => {
    const [controllerProps, inputProps] = splitProps(props);
    return (React.createElement(ControlledInputBase, { ...controllerProps, render: ({ ref: _ref, value, onChange, ...rest }) => (React.createElement(Checkbox, { ...rest, ...inputProps, infoText: infoText, checked: value ?? nullValue, onChange: (checked) => {
                onChange(checked);
                onChangeExternal?.(checked);
            } })) }));
};
